// extracted by mini-css-extract-plugin
export default {"root":"styles_root__02hts","loadingImg":"styles_loadingImg__JTvkK","spin":"styles_spin__F-HF3","text":"styles_text__FjKHb"};